import * as React from 'react';

const CartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path d="M7.842 26.668c-.427 0-.807-.12-1.14-.361a1.726 1.726 0 0 1-.665-.977L2.986 14.499a.86.86 0 0 1 .135-.803c.179-.24.43-.361.754-.361h6.457L15.237 6a.998.998 0 0 1 .354-.316.967.967 0 0 1 .428-.091c.16 0 .303.034.428.104.125.069.243.179.354.33l4.851 7.307h6.482c.324 0 .58.12.768.361a.841.841 0 0 1 .148.803l-3.136 10.83c-.111.41-.333.737-.666.978a1.853 1.853 0 0 1-1.114.361H7.842Zm-.102-1.026h16.523c.188 0 .35-.055.487-.166a.847.847 0 0 0 .282-.449l2.982-10.667H3.996L6.97 25.027a.847.847 0 0 0 .282.449c.137.11.3.166.488.166Zm8.271-4.615a.961.961 0 0 0 .714-.311c.201-.208.302-.45.302-.725a.961.961 0 0 0-.312-.714 1.01 1.01 0 0 0-.724-.301.961.961 0 0 0-.714.311 1.01 1.01 0 0 0-.302.725c0 .275.104.513.312.714.207.2.449.301.724.301Zm-4.43-7.692h8.817l-4.405-6.667-4.412 6.667Z" />
    </g>
  </svg>
);

export default CartIcon;
